<script setup>
import WrImageContent from "~/components/global/WrImageContent.vue";

const route = useRoute();
const slug = route.params.slug;

const config = useRuntimeConfig();
const baseURL = config.public.baseUrl;
const { data, error } = await useFetch(
  `${baseURL}/content/solutions/${slug}-content.json`
);

if (error.value || !data.value) {
  throw createError({
    statusCode: 404,
    statusMessage: "Page not found",
  });
}

useHead({
  title: data?.value.meta_tags.title || "",
  meta: data?.value.meta_tags.meta || [],
});

definePageMeta({
  layout: "services-layout",
});

const visible = ref(false);

const openModal = () => {
  visible.value = true;
};


</script>

<template>
  <!-- Hero Banner -->
  <WrHeroBanner :data="data.header" @open-modal="openModal" />

  <!-- Google Autocomplete -->
  <section class="px-4 mt-10 relative z-10 mx-auto">
    <div class="max-w-screen-xl mt-16 mx-auto space-y-8">
      <FloatingList
        :heading="data?.google_autocomplete?.heading"
        :subheading="data?.google_autocomplete?.subheading"
        :expertisetext="data?.expertise?.expertisetext"
        :textcontent="data?.expertise?.textcontent"
        :text="data?.google_autocomplete?.text"
        :keywords="data?.google_autocomplete?.keywords"
      />
      <GoogleRating />
    </div>
  </section>

  <section class="mt-10 bg-[#5F4CA4] dark:bg-transparent pt-3">
    <div class="max-w-screen-xl px-4 mt-16 mx-auto">
      <WrContactUsCarouselSection :data="data.contact_us_carousel" />
    </div>
  </section>

  <section class="max-w-screen-lg px-4 xl:mt-28 mt-16 relative z-10 mx-auto">
    <div class="max-w-screen-xlmt-16 mx-auto">
      <WrExpertiseSection :expertise="data?.expertise" />
    </div>
  </section>

  <section class="max-w-screen-xl px-4 mt-16 relative z-10 mx-auto">
    <WrWhoAreWeCard
      :heading="data?.service_content?.heading"
      :subheading="data?.service_content?.subheading"
      :content="data.service_content.text"
    />
  </section>

  <section class="max-w-screen-xl px-4 sm:px-10 lg:mt-20 relative z-10 mx-auto">
    <div class="max-w-screen-xl lg:mt-16 mx-auto">
      <WrImageContent
        :whyChooseUs="data?.why_choose_us"
        src="/images/why-chose-us.webp"
        height="360"
        width="466"
        :text="text"
        header="Let’s start together"
        @openModal="openModal"
      />
    </div>
  </section>

  <section class="max-w-screen-xl px-4 mt-20 relative z-10 mx-auto">
    <WrOurPromiseSection :data="data?.our_promises" />
  </section>

  <!-- Our Capabilities starts -->
  <WrOurServiceSection />

  <!-- Selected Projects -->
  <section
    class="relative z-10 py-10 lg:pb-28 overflow-visible order-9"
  >
    <div class="max-w-screen-lg mx-auto px-4 w-full relative">
       <div class="hidden  dark:block opacity-30  md:size-[764px] rounded-full 
         bg-[linear-gradient(136.28deg,_rgba(51,4,79,0)_30.43%,_#260049_54.53%,_#36006F_92.37%)] 
         absolute -top-[30%] -left-[67%]">
      </div>

      <div class="hidden  dark:block opacity-50 size-[190px] rounded-full 
         bg-[image:var(--bg-circle-top-light)] 
         absolute -bottom-[15%] right-0 top-0">
      </div>
      <WrSelectedProject />
    </div>
  </section>

  <section
    class="relative pt-10 lg:pt-20 overflow-hidden max-w-screen-xl mx-auto px-4 z-20"
  >
    <h2 class="text-center mb-11">
      <WrGradientText text="Trusted for excellence and efficiency" />
      <p class="text-lg text-[var(--foreground)] font-anvtgrade-book">
        Webreinvent is trusted by leading organisations to enhance their
        development and operational efficiency.
      </p>
    </h2>
    <!-- Carousel Section -->
    <WrTestimonialCardCarousel />
    <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-7"
      >View All</WrButton
    >
  </section>
  <WrContactFormPopup :isOpen="visible" @close="visible = false" class="z-30" />
</template>
